import Button from '../../components/base/Button';
import Seo from '../../components/feature/Seo';
import { PHONE_DISPLAY, PHONE_HREF, WHATSAPP_HREF } from '../../lib/schiek-content';

const emergencySteps = [
  'Warnblinkanlage einschalten und Warnweste anziehen.',
  'Wenn möglich, sicheren Ort aufsuchen und Abstand zur Fahrbahn halten.',
  'Bei Verletzten, Gefahr oder Unfall zuerst Polizei/Rettung alarmieren.',
  'Standort, Fahrzeug und Situation bereithalten und Schiek anrufen.',
];

export default function NotrufPage() {
  return (
    <main className="bg-white pt-28 pb-20">
      <Seo
        title="Notruf Abschleppdienst Berlin | Schiek 24/7"
        description="24/7 Kontakt für Abschlepphilfe in Berlin. Bei Panne, Unfall oder blockierter Einfahrt Schiek direkt anrufen."
        path="/notruf"
      />

      <section className="px-5" aria-labelledby="emergency-heading">
        <div className="mx-auto max-w-6xl rounded-[2rem] bg-slate-950 p-6 text-white shadow-[0_28px_90px_rgba(2,6,23,0.35)] md:p-10">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.24em] text-sky-300">24/7 Kontakt</p>
          <h1 id="emergency-heading" className="max-w-4xl text-3xl font-semibold leading-tight sm:text-5xl">
            Panne oder Unfall in Berlin? Erst sichern, dann direkt anrufen.
          </h1>
          <p className="mt-5 max-w-3xl text-base leading-relaxed text-slate-200 sm:text-lg">
            Schiek ist für akute Abschlepp- und Pannenfälle rund um die Uhr erreichbar. Am Telefon klären wir
            Standort, Fahrzeug, Situation und den nächsten sinnvollen Schritt.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button href={PHONE_HREF} size="lg" className="whitespace-normal bg-white px-6 text-sm !text-[#0F3D8C] hover:bg-slate-100">
              <i className="ri-phone-line mr-2 text-lg" aria-hidden="true" />
              {PHONE_DISPLAY}
            </Button>
            <Button href={WHATSAPP_HREF} variant="secondary" size="lg" className="whitespace-normal px-6 text-sm">
              Standort per WhatsApp senden
            </Button>
          </div>
        </div>
      </section>

      <section className="px-5 py-16" aria-labelledby="emergency-steps-heading">
        <div className="mx-auto max-w-6xl">
          <h2 id="emergency-steps-heading" className="text-2xl font-semibold text-slate-950 sm:text-3xl">
            Was Sie jetzt tun sollten
          </h2>
          <div className="mt-8 grid gap-4 md:grid-cols-4">
            {emergencySteps.map((step, index) => (
              <article key={step} className="rounded-3xl border border-slate-200 bg-white p-5 shadow-[0_14px_36px_rgba(15,23,42,0.05)]">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#0F3D8C] text-sm font-semibold text-white">
                  {index + 1}
                </span>
                <p className="mt-4 text-sm leading-relaxed text-slate-700">{step}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="px-5" aria-labelledby="emergency-info-heading">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3">
          {[
            ['Panne', 'Standort, Fahrzeugtyp und Problem nennen. Wir prüfen, ob Hilfe vor Ort reicht oder abgeschleppt werden muss.'],
            ['Unfall', 'Bei Verletzten zuerst Rettung/Polizei. Danach kann Schiek Bergung und Transport abstimmen.'],
            ['Falschparker', 'Privatgrund, Einfahrt oder Hof? Berechtigung, Fotos und Standort bereithalten.'],
          ].map(([title, text]) => (
            <article key={title} className="rounded-3xl bg-slate-50 p-6">
              <h3 className="text-lg font-semibold text-slate-950">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-700">{text}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
